import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';





const Nikitsky6 = () => {

    const [clickedPrez, setClickedPrez] = React.useState(false);
    const [clickedPrezEng, setClickedPrezEng] = React.useState(false);
    const [clickedVideo, setClickedVideo] = React.useState(false);
    const [clickedArh, setClickedArh] = React.useState(false);
    const [clickedInt, setClickedInt] = React.useState(false);
    const [clickedLob, setClickedLob] = React.useState(false);
    const [clickedOkr, setClickedOkr] = React.useState(false);
    const [clickedWind1, setClickedWind1] = React.useState(false);
    const [clickedWind2, setClickedWind2] = React.useState(false);
    
    let tg = window.Telegram.WebApp;
    
    tg.MainButton.text = "Скачать"; //изменяем текст кнопки 
    tg.MainButton.setText("Скачать"); //изменяем текст кнопки иначе
    tg.MainButton.textColor = "#000000"; //изменяем цвет текста кнопки
    tg.MainButton.color = "#CED8DD"; //изменяем цвет бэкграунда кнопки
    tg.MainButton.setParams({"color": "#CED8DD"}); 
    



    const handleChangeChekced = (e) => {
        setClickedPrez(e.target.checked)
        
        if(e.target.checked == false 
            && clickedPrezEng == false 
            && clickedVideo == false 
            && clickedArh == false 
            && clickedInt == false 
            && clickedLob == false 
            && clickedOkr == false 
            && clickedWind1 == false 
            && clickedWind2 == false 
        ){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeEngChekced = (e) => {
        setClickedPrezEng(e.target.checked)
        
        if(clickedPrez == false 
            && e.target.checked == false 
            && clickedVideo == false 
            && clickedArh == false 
            && clickedInt == false 
            && clickedLob == false 
            && clickedOkr == false 
            && clickedWind1 == false 
            && clickedWind2 == false ){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeVideoChekced = (e) => {
        setClickedVideo(e.target.checked)
        
        if(clickedPrez == false 
            && clickedPrezEng == false 
            && e.target.checked == false 
            && clickedArh == false 
            && clickedInt == false 
            && clickedLob == false 
            && clickedOkr == false 
            && clickedWind1 == false 
            && clickedWind2 == false){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeArhChekced = (e) => {
        setClickedArh(e.target.checked)
        
        if(clickedPrez == false 
            && clickedPrezEng == false 
            && clickedVideo == false 
            && e.target.checked == false 
            && clickedInt == false 
            && clickedLob == false 
            && clickedOkr == false 
            && clickedWind1 == false 
            && clickedWind2 == false){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeIntChekced = (e) => {
        setClickedInt(e.target.checked)
        
        if(clickedPrez == false 
            && clickedPrezEng == false 
            && clickedVideo == false 
            && clickedArh == false 
            && e.target.checked == false 
            && clickedLob == false 
            && clickedOkr == false 
            && clickedWind1 == false 
            && clickedWind2 == false){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeLobChekced = (e) => {
        setClickedLob(e.target.checked)
       
        if(clickedPrez == false 
            && clickedPrezEng == false 
            && clickedVideo == false 
            && clickedArh == false 
            && clickedInt == false 
            && e.target.checked == false 
            && clickedOkr == false 
            && clickedWind1 == false 
            && clickedWind2 == false ){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeOkrChekced = (e) => {
        setClickedOkr(e.target.checked)
        
        if(clickedPrez == false 
            && clickedPrezEng == false 
            && clickedVideo == false 
            && clickedArh == false 
            && clickedInt == false 
            && clickedLob == false 
            && e.target.checked == false 
            && clickedWind1 == false 
            && clickedWind2 == false){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeWind1Chekced = (e) => {
        setClickedWind1(e.target.checked)
        
        if(clickedPrez == false 
            && clickedPrezEng == false 
            && clickedVideo == false 
            && clickedArh == false 
            && clickedInt == false 
            && clickedLob == false 
            && clickedOkr == false 
            && e.target.checked == false 
            && clickedWind1 == false){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }

    const handleChangeWind2Chekced = (e) => {
        setClickedWind2(e.target.checked)
        
        if(clickedPrez == false 
            && clickedPrezEng == false 
            && clickedVideo == false 
            && clickedArh == false 
            && clickedInt == false 
            && clickedLob == false 
            && clickedLob == false 
            && clickedWind1 == false 
            && e.target.checked == false){
            tg.MainButton.hide()
        }
        else{
            tg.MainButton.show()
        }
    }


  
    const sendDataToTelegram = () => {
        tg.sendData(`{"clickedPrez": "${clickedPrez}", 
        "clickedPrezEng":  "${clickedPrezEng}", 
        "clickedVideo": "${clickedVideo}", 
        "clickedArh":  "${clickedArh}", 
        "clickedInt":  "${clickedInt}", 
        "clickedLob": "${clickedLob}", 
        "clickedLob":  "${clickedLob}", 
        "clickedWind1":  "${clickedWind1}",
        "clickedWind2":  "${clickedWind2}"}`);
        
      }
    


 
  
      React.useEffect(() => {
        tg.onEvent('mainButtonClicked', sendDataToTelegram)
        return () => {
          tg.offEvent('mainButtonClicked', sendDataToTelegram)
        }
      }, [sendDataToTelegram])


    useEffect(() => {
        window.scrollTo(0, 0)
        tg.MainButton.hide()
      }, [])

      
    return (
        <Grid >
            <Box sx={{ p: 3 }} >
                <Grid container spacing={3} direction="column" alignItems="center" style={{ justifyContent: "center" }}>
                    <Box sx={{ pt: 3 }} >
                        <img src='../../img/nikitsky.png' alt="Logo" width="150" />
                    </Box>
                    <Box sx={{ pt: 3 }} >
                        <img src='../../img/Nikitskaya_6_2.jpg' width="380" />
                    </Box>

                </Grid>
            </Box>
            <Box sx={{ p: 3 }} >
                <Grid container direction="column" alignItems="left" style={{ justifyContent: "center" }}>

                    <Typography sx={{ mb: 4 }} style={{ color: "rgb(100, 100, 100)", fontSize: '20px' }}>ИНФОРМАЦИЯ О ПРОЕКТЕ</Typography>
                    <Typography sx={{ mb: 1 }} style={{ color: "rgb(100, 100, 100)", fontSize: '20px' }}>Презентации</Typography>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox color="default" checked={clickedPrez} onChange={handleChangeChekced} />} label="Презентация" />
                        <FormControlLabel control={<Checkbox color="default" checked={clickedPrezEng} onChange={handleChangeEngChekced} />} label="Презентация на английском языке" />
                    </FormGroup>

                    <Typography sx={{ mb: 1, mt: 3 }} style={{ color: "rgb(100, 100, 100)", fontSize: '20px' }}>Фото, видео и рендеры</Typography>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox color="default" checked={clickedVideo} onChange={handleChangeVideoChekced} />} label="Видеоролик о проекте" />
                        <FormControlLabel control={<Checkbox color="default" checked={clickedArh} onChange={handleChangeArhChekced} />} label="Архитектура" />
                        <FormControlLabel control={<Checkbox color="default" checked={clickedInt} onChange={handleChangeIntChekced} />} label="Интерьеры квартир" />
                        <FormControlLabel control={<Checkbox color="default" checked={clickedLob} onChange={handleChangeLobChekced} />} label="Лобби и паркинг" />
                        <FormControlLabel control={<Checkbox color="default" checked={clickedOkr} onChange={handleChangeOkrChekced} />} label="Фото окружения" />
                    </FormGroup>

                    <Typography sx={{ mb: 1, mt: 3 }} style={{ color: "rgb(100, 100, 100)", fontSize: '20px' }}>Виды из окон</Typography>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox color="default" checked={clickedWind1} onChange={handleChangeWind1Chekced} />} label={`Кремль и Воздвиженка`} />
                        <FormControlLabel control={<Checkbox color="default" checked={clickedWind2} onChange={handleChangeWind2Chekced} />} label="Арбат и Бульвары" />
                    </FormGroup>
                </Grid> 
            </Box>
        </Grid>
    );
};

export default Nikitsky6;